import React from 'react';

import { FGBLocalStorage } from '../helpers/FGBStorage';

import { fireGTMMetric } from './Google';
import { EmitMetric } from './VisibilityPixel/VisibilityPixel';

export const SignUpMetrics = ({ user }) => {
    const onFireSignUpMetric = async () => {
        const Cookies = (await import('js-cookie')).default;
        const signUpTrigger = Cookies.get('REGISTRATION-TRIGGER');
        const loginMetrics = FGBLocalStorage.getItem('last_login_metrics') || {};

        if (signUpTrigger && signUpTrigger !== 'OFF') {
            const loginCookie = {};
            if (Cookies.get('LOGIN-TRIGGER')) {
                loginCookie.login_trigger = Cookies.get('LOGIN-TRIGGER');
            }
            EmitMetric({
                registration_source: signUpTrigger,
                user_registered: 1,
                user_id: user.id,
                ...loginMetrics,
                ...loginCookie,
            });
        }

        if (user.isLoggedIn) {
            fireGTMMetric(
                'user-registered',
                '',
                '',
                {
                    userId: user.id,
                    userRegistration: '1',
                    label: 'registration',
                    category: 'userRegistered',
                },
                'dataLayer'
            );
            Cookies.set('REGISTRATION-TRIGGER', 'OFF');
        }
    };

    React.useEffect(() => {
        onFireSignUpMetric();
    }, []);
    return null;
};
